import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { usePortalStore } from '../../stores/portalStore';
import { useNavTree } from '../../hooks/useNavTree';
import IconRail from './IconRail';

interface Props {
  onRenameSection?: (id: string, title: string) => Promise<void>;
  onDeleteSection?: (id: string) => Promise<void>;
}

export default function Sidebar({ onRenameSection, onDeleteSection }: Props) {
  const { selectedSectionId, setSelectedSection } = usePortalStore();
  const { sections, loading, error, addSection } = useNavTree();

  if (loading) {
    return (
      <Box
        component="nav"
        aria-label="Sidebar"
        sx={{
          width: 72,
          display: { xs: 'none', lg: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
          borderRight: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        component="nav"
        aria-label="Sidebar"
        sx={{
          width: 72,
          display: { xs: 'none', lg: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
          borderRight: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.default',
          p: 1,
        }}
      >
        <Typography variant="caption" color="error" sx={{ textAlign: 'center' }}>
          Load failed
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="nav"
      aria-label="Sidebar navigation"
      sx={{
        display: { xs: 'none', lg: 'flex' },
        flexShrink: 0,
        bgcolor: 'background.default',
        borderRight: '1px solid',
        borderColor: 'divider',
        height: '100%',
      }}
    >
      <IconRail
        sections={sections}
        selectedSectionId={selectedSectionId}
        onSelectSection={setSelectedSection}
        onAddSection={addSection}
        onRenameSection={onRenameSection}
        onDeleteSection={onDeleteSection}
      />
    </Box>
  );
}
